<template>
  <div id="app">
    <notifications></notifications>
    <router-view :key="$route.fullPath" />
  </div>
</template>
<script>
  import i18n from './i18n';


  export default {
    name: 'App',
    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: i18n.t('default_title'),
      // all titles will be injected into this template
      // titleTemplate: '%s | My Awesome Webapp'
    }
  }
</script>
